import { render, staticRenderFns } from "./PropertySignUp.vue?vue&type=template&id=27855671&scoped=true&"
import script from "./PropertySignUp.vue?vue&type=script&lang=js&"
export * from "./PropertySignUp.vue?vue&type=script&lang=js&"
import style0 from "./PropertySignUp.vue?vue&type=style&index=0&id=27855671&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27855671",
  null
  
)

export default component.exports